export const initialDividendModalState = {
  product: '',
  fromWallet: '',
  sentAmount: '0',
  sentCurrency: '',
  sentCommission: '0',
  sentCommissionCurrency: '',
  sentExchangeRate: '0',
  receivedAmount: '0',
  receivedCurrency: '',
  receivedCommission: '0',
  receivedCommissionCurrency: '',
  receivedExchangeRate: '0',
  dateTime: '',
  comment: '',
  toWallet: '',
  operationType: '',
  id: '',
  walletId: '',
}
